import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
  path: '',
  component: () => import_latest_version_module(),
  children: [
    {
      path: '/admin/supplier-detail',
      name: 'admin-supplier-detail',
      component: () => import(/* webpackChunkName: "page-admin-supplier-management-supplier-detail" */ `./1.0.1/index.vue`),
      meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "供应商详情"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "供应商管理"
                                        },
                                        {
                                                  name: "供应商列表"
                                        },
                                        {
                                                  name: "供应商详情"
                                        }
                              ]
                    }
          }
},
    },
  ],
};
